export const ActionTypes = {
    CHECK_SIGN: 'CHECK_SIGN',
    CHECK_SIGN_PENDING: 'CHECK_SIGN_PENDING',
    CHECK_SIGN_FULFILLED: 'CHECK_SIGN_FULFILLED',
    CHECK_SIGN_REJECTED: 'CHECK_SIGN_REJECTED',

    RESET_SIGN: 'RESET_SIGN'
}